<meta property="og:site_name" content="www.codesroots.com">
<meta name="keywords" content=" اقوي شركة دعم فني في تصميم المواقع,دعم فني ممتاز,دعم فني علي مدار الساعة">

<section class="support-page">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <h1 class="section-title">
                    الدعم الفنى
                </h1>
                <h3>
                    نبذل قصارى جهدنا لاننا نسعى الى تقديم افضل خدمه لعميلنا العزيز حيث اننا نقدم لك خدمه حقيقيه متواجده 24 ساعة , و لكى نحقق له افضل متابعه لمواقعه نقدم له خطط مميزه للدعم الفنى يفوم به نخبه من خبراء الدعم الفنى المتميزين تصل خبرتهم الى اكثر من 8 سنوات ..        
                </h3>
            </div>
            <div class="col-12">
                <app-fatc-boxes [facts]='facts'></app-fatc-boxes>
            </div>
            <div class="col-12" style="margin-top: 40px">
                <h3 class="inner-title">
                    اختر العرض المناسب لك
                </h3>
                <app-packages [packages]='packages'></app-packages>
            </div>            
        </div>
    </div>
</section>